import React from "react";
import { domToReact } from 'html-react-parser';
import HowTo from "../../../../../components/Molecules/HowTo/HowTo";
import {
    wpHowToClass,
    wpHowToTotalTimeClass,
    wpHowToDescriptionClass,
    wpHowToStepsClass
} from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const classIncludes = (childClass, classNeedle) =>
    childClass.split(' ').includes(classNeedle);

const extractSectionElements = ( sectionChildren, replaceFn ) =>
{
    const sectionExtracts = {
        timeToReadSection: '',
        descriptionSection: '',
        listSection: ''
    }
    const children = sectionChildren.filter(child => child.type === 'tag');

    children?.forEach( child =>
    {
        if ( classIncludes( child?.attribs?.class, wpHowToTotalTimeClass))
        {
            sectionExtracts.timeToReadSection = {...domToReact([child], replaceFn())};
        }
        if ( classIncludes( child?.attribs?.class, wpHowToDescriptionClass))
        {
            sectionExtracts.descriptionSection = {...domToReact([child], replaceFn())};
        }
        if ( classIncludes( child?.attribs?.class, wpHowToStepsClass))
        {
            sectionExtracts.listSection = domToReact([child], replaceFn());
        }
    });

    return sectionExtracts;
};

const toHowTo = ( parserData ) =>
{
    const { parserOptions: {replaceFn} } = parserData;
    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }) =>
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'div') return null;
        if (!attribs?.class) return null;
        if (!classIncludes(attribs.class, wpHowToClass)) return null;
        if (!children || !Array.isArray(children)) return null;
        
        const { timeToReadSection, descriptionSection, listSection } = extractSectionElements(children, replaceFn);
        
        return <HowTo listChildren={listSection?.props?.children}>{[timeToReadSection, descriptionSection]}</HowTo>
    };
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;        
}
export default toHowTo;